import WebServiceRequest from '../Api/WebServiceRequest'


class GetSingleWalletNetworks extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('GET')
  }

  setId(id) {
    super.setTag(`WalletNetworks/${id}`)
  }
}

class DeleteWalletNetworks extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('DELETE')
  }
  setId(id) {
    super.setTag(`WalletNetworks/${id}`)
  }
}

class GetWalletNetworks extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('GET')
    super.setTag('WalletNetworks')
  }
  setParams(data) {
    super.setRequestParam(data)
  }
}


class UpdateWalletNetwork extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('PUT')
    super.setTag('WalletNetworks')
  }
  setParams(data) {
    super.setRequestParam(data)
  }
  setPayload(data){
    super.setRequestParamDataObj(data)
  }
}

class CreateWalletNetworks extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('POST')
    super.setTag('WalletNetworks')
  }
  setPayload(data){
    super.setRequestParamDataObj(data)
  }
}


export {
  GetSingleWalletNetworks,
  GetWalletNetworks,
  DeleteWalletNetworks,
  UpdateWalletNetwork,
  CreateWalletNetworks
}
